












































































































import Vue from 'vue'
import { defaultPosterImage, userAvatarImage } from '../../helper/constants'
export default Vue.extend({
  props: {
    productId: String,
    productTitle: String,
    posterImage: String,
    productDescription: String,
    instructorName: String,
    instructorHeadshot: String,
    activeProduct: String,
    upsellProduct: {
      type: Boolean,
      default: false
    },
    sliderCard: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      userAvatarImage,
      defaultPosterImage,
      height: '108px'
    }
  },
  mounted() {
    this.setCardHeight()
    window.addEventListener('resize', this.setCardHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setCardHeight)
  },
  methods: {
    setCardHeight() {
      const cardClass = this.upsellProduct
        ? '.product-modal-image'
        : '.product-image'
      const card = document.querySelector(cardClass) as HTMLElement
      this.height = card?.offsetWidth / 1.77 + 'px'
    }
  },
  filters: {
    truncateText(text: string, MAX_LENGTH = 25): string {
      if (text.length < MAX_LENGTH) return text

      return text.slice(0, MAX_LENGTH) + '...'
    }
  }
})
